import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import type { ContainerDefinition } from '@wix/thunderbolt-components';
import { IContainerProps } from '../Container.types';
import { ARIA_LABEL_KEY, ARIA_LABEL_NAMESPACE } from './shared/constants';

export const props = withCompInfo<
  IContainerProps,
  ContainerDefinition,
  IContainerProps
>()(['translate'], ({ translate }, carmiProps) => {
  return {
    ...carmiProps,
    translations: {
      ariaLabel: translate(ARIA_LABEL_NAMESPACE, ARIA_LABEL_KEY),
    },
  };
});

export const css = withCompInfo()(
  ['styleProperties'],
  ({ styleProperties }, carmiData) => {
    const carmiProps = carmiData || {};
    const blurValue = styleProperties['backdrop-blur'];
    const hasBackdropBlur =
      styleProperties['backdrop-blur'] !== undefined &&
      styleProperties['backdrop-blur'] !== '0px';
    return hasBackdropBlur
      ? {
          ...carmiProps,
          'backdrop-filter': `blur(${blurValue})`,
          '-webkit-backdrop-filter': `blur(${blurValue})`,
        }
      : carmiProps;
  },
);

export default createComponentMapperModel({ props, css });
